// extracted by mini-css-extract-plugin
module.exports = {"base":"confirmDialog_base__ncsE0","info":"confirmDialog_info__1OCe8"};